const generateStyle = (componentTheme, props, state) => {

  return {
    globalStyles: {
      'body': {
        background: componentTheme.background
      }
    }
  }
}

export default generateStyle